export default "__VITE_ASSET__BPoadhoq__"